import template from "./entity-business-charges.html";
import "./entity-business-charges.less";
import cloneDeep from "clone-deep";

import { FORM_BUSINESS_CHARGES } from "routes";

import {
	ENTITY_TRANSLATION_KEYS, 
	I18NextContext 
} from "../../../../../../../services/i18nService";
import { globs } from "../../../../../../../services/globs";

// type FeeTypeDto = { Code: 'PERCENT' | 'FLAT' };
// type FeeDto = {
//     Type: FeeTypeDto
//     Amount: number //decimal
//     IsActive: boolean
// };

export function controller($logger, api, loadingService, $uibModal, $scope, securityService, appState) {
	const ctrl = this;

	ctrl.i18n = I18NextContext.Instance;
	ctrl.ENTITY_TRANSLATION_KEYS = ENTITY_TRANSLATION_KEYS;

	ctrl.$onInit = () => {
		ctrl.canReadBusinessFeesGlob = globs.business.byType("*").fees.byType("*").read;
		ctrl.canUpdateBusinessFeeGlob = globs.business.byType("*").fees.byType("*").update;
		ctrl.canCreateBusinessFeeGlob = globs.business.byType("*").fees.byType("*").create;
		
		$scope.$watch(() => ctrl.businessId, loadCharges);
	};

	ctrl.editCharge = async(charge) => {
		const chargeUpdate = await $uibModal.open({
			component: "entity-business-charge-modal",
			size: "smmd",
			backdrop: "static",
			resolve: {
				charge: () => charge,
				save: () => saveCharge
			}
		}).result;

		const matchindex = ctrl.charges.findIndex(c => c.Code === chargeUpdate.Code);
		if(matchindex !== -1) {
			ctrl.charges[matchindex] = chargeUpdate;
		}
		else {
			ctrl.charges.push(chargeUpdate);
		}

		ctrl.availableCharges = cloneDeep(ctrl.charges.filter(c => c.IsActive));

		return chargeUpdate;
	};

	async function saveCharge(charge) {
		const verb = charge.Code !== undefined ? "put" : "post";
		const saveBusiness = ctrl[verb](FORM_BUSINESS_CHARGES(appState.forms.selected.Id, ctrl.businessId), charge, charge.ApplyToCurrentProducts);
		const resp = await loadingService.watch(saveBusiness);

		return resp;
	}

	async function loadCharges() {
		const canReadCharges = securityService.isPatternAllowed(ctrl.canReadBusinessFeesGlob);
		if(ctrl.businessId === undefined || !canReadCharges) {
			ctrl.charges = [];
			ctrl.availableCharges = [];
			return;
		}
		const getCharges = api.get(FORM_BUSINESS_CHARGES(appState.forms.selected.Id, ctrl.businessId));
		
		const charges = await loadingService.watch(getCharges);
		ctrl.charges = charges.filter(c => c.IsActive);
		ctrl.availableCharges = cloneDeep(ctrl.charges);
	}
}

export default angular.module("vesl.components.entity-business-charges", [])
	.component("entityBusinessCharges", {
		controller,
		template,
		bindings: {
			businessId: "<",
			availableCharges: "=",
			put: "=",
			post: "="
		}
	})
	.name;
